import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    addAccountFormValue: {
        account_name: "",
        account_id: "",
        parent_link: "",
        legal_business_name: "",
        account_type: "",
        ref_id: "",
        zoho_contact_id: "",
    },
    page: 1,
    selectedValue: 10,
    pageNumber: 1,
    historySelectedValue: 10,
    historyPage: 1,
    visibleColumns: [
        { name: "Billing Address", visible: false },
        { name: "GSTIN", visible: false },
        { name: "Services", visible: false },
        { name: "Operational Location", visible: false },
        { name: "Department", visible: false },
        { name: "Ref Id", visible: false },
        { name: "Bank Details", visible: false },
        { name: "Other Details", visible: false },
    ],
}

const AccountSlice = createSlice({
    name: "accounts",
    initialState,
    reducers: {
        setAddAccountForm: (state: any, payload: any) => {
            state.addAccountFormValue = payload?.payload
        },
        setPages: (state, action) => {
            state.page = action?.payload
        },
        setSelectedValues: (state, action) => {
            state.selectedValue = action?.payload
        },
        setHistoryPages: (state, action) => {
            state.historyPage = action?.payload
        },
        setHistorySelectedValues: (state, action) => {
            state.historySelectedValue = action?.payload
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action?.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
    },
})
export const {
    setAddAccountForm,
    setPages,
    setSelectedValues,
    setPageNumber,
    setHistoryPages,
    setHistorySelectedValues,
    setVisibleColumns,
} = AccountSlice.actions
export default AccountSlice.reducer
